import React, { Component } from 'react';

export default class HomePage extends Component {
  render() {
    return (
      <>
        <div
          className='container-fluid'
          style={ {
            height: '5%',
            backgroundImage: 'url(./assets/img/content/service-1.jpg)',
            backgroundSize: '50%',
            backgroundPositionY: '50px',
            backgroundPositionX: '500px',
            backgroundColor: '#ffffff',
            backgroundRepeat: 'no-repeat',
          } }>
          <div className='container'>
            <div className='row align-item-center text-left'>
              <div className='col-lg-5 my-lg-7'>
                <h1 className='display-2 text-info'>Layanan Publik</h1>
                <p className='lead pb-4 '>
                    Nikmati fitur pendaftaran dan perijinan secara Online
                    dengan mudah dari mana saja
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='container-fluid'>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <div class='card mt-3'>
                  <div class='card-header'>
                    <h1>Layanan Publik</h1>
                  </div>
                  <div class='card-body'></div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}
